const baseURL = `/proxy/fnf-office-rag-api//api/chat`;

export default {
  /**
   * @GET FAQ 리스트 가져오기
   */
  FTALK_FAQ_LIST: `${baseURL}/faq-list`,

  /**
   * @POST Session 생성
   */
  FTALK_SESSION_CREATE: `${baseURL}/session`,

  /**
   * @POST Session healthcheck
   */
  FTALK_SESSION_CHECK: `${baseURL}/session/health`,

  /**
   * @POST Session별 채팅 내역 확인
   */
  FTALK_TALK_HISTORY: `${baseURL}/session/history`,

  /**
   * @POST 메시지 전송
   */
  FTALK_TALK_START: `${baseURL}/chat-message`,

  /**
   * @POST 피드백 전송
   */
  FTALK_FEEDBACK_SEND: `${baseURL}/feedback`,
};
